import _classCallCheck from "/Users/lenkazivkovic/Documents/gatsby_websites/Woocommerce/tcp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/lenkazivkovic/Documents/gatsby_websites/Woocommerce/tcp/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { addUniqueItem, removeItem } from './array.mjs';
var SubscriptionManager = /*#__PURE__*/function () {
  function SubscriptionManager() {
    _classCallCheck(this, SubscriptionManager);
    this.subscriptions = [];
  }
  _createClass(SubscriptionManager, [{
    key: "add",
    value: function add(handler) {
      var _this = this;
      addUniqueItem(this.subscriptions, handler);
      return function () {
        return removeItem(_this.subscriptions, handler);
      };
    }
  }, {
    key: "notify",
    value: function notify(a, b, c) {
      var numSubscriptions = this.subscriptions.length;
      if (!numSubscriptions) return;
      if (numSubscriptions === 1) {
        /**
         * If there's only a single handler we can just call it without invoking a loop.
         */
        this.subscriptions[0](a, b, c);
      } else {
        for (var i = 0; i < numSubscriptions; i++) {
          /**
           * Check whether the handler exists before firing as it's possible
           * the subscriptions were modified during this loop running.
           */
          var handler = this.subscriptions[i];
          handler && handler(a, b, c);
        }
      }
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.subscriptions.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.subscriptions.length = 0;
    }
  }]);
  return SubscriptionManager;
}();
export { SubscriptionManager };